import React, { useState, useEffect, useRef } from 'react';
import equal from 'fast-deep-equal';
import './AnomalyFilters.scss';
import { Button, Icon, Select } from '@scuf/common';
import Dropdown from 'src/pages/overview/Dropdown';
import { ILookUpDetailModal } from 'src/models/IOverviewModel';
import { IAnomaliesFilterModel } from 'src/models/IAllOpportunitiesModel';
import { ANOMALIES_LOOKUP_NAMES, OVERVIEW_DOMAIN_CATEGORY, VIEW_TYPE, STATUS_TYPES, UNASSIGNED_ANOMALIES, COUNTRY_NAME, USER_ROLE } from 'src/constants/constants';
import Multiselect from '../../pages/overview/Multiselect';
import { useSelector, useDispatch } from 'react-redux';
import {
    getLookupStatusSelector,
    getDashboardFiltersSelector,
    addAllAnomalyFilters,
    addDashboardFilter,
    getallOpportunities,
    getAllAnomalyFiltersSelector,
    getPostFiltersSelector
} from 'src/slices/allOpportunitySlice';
import { getallSamplingOpportunities, addSamplingFilters, getSamplingFiltersSelector } from '../../slices/samplingSlice';
import { isOverviewDashboard } from 'src/utils/dashboardUtilis';
import { getOverviewViewType, setOverviewViewType, } from 'src/slices/overviewSlice';
import { getFilterOptions } from 'src/services/Opportunities';
import { mergeFilters, mapFilterColumns, getUniqueoptions } from 'src/utils/filterUtils';
import { getCurrentRole } from 'src/slices/onBoardingSlice';
import { addOrphanFilters, getallOrphanOpportunities, getOrphanFiltersSelector } from 'src/slices/orphanSlice';
import FontIcon from '../FontIcon/FontIcon';
import { getMessage } from '../../message/utils';

interface IAnomalyFiltersProps {
    onFiltersClick: Function
    isFilterOpen: boolean
    filterClose: Function
    onApplyOrReset:Function
    filterDisable?: boolean
    isSamplingFilter?: boolean
    isOrphanFilter?: boolean
}
const AnomalyFilters = (props: IAnomalyFiltersProps) => {
    const dashboardFilter = useSelector(getDashboardFiltersSelector);
    const allAnomalyFilters = useSelector(getAllAnomalyFiltersSelector);
    const samplingFilter = useSelector(getSamplingFiltersSelector);
    const orphanFilter = useSelector(getOrphanFiltersSelector);
    const [domainOptions, setDomainOptions] = useState<any>([]);
    const [alertOptions, setAlertOptions] = useState<any>([]);
    const [statusOptions, setStatusOptions] = useState<any>([]);
    const [reviewerOptions, setReviewerOptions] = useState<any>([]);
    const [orgOptions, setOrgOptions] = useState<any>([]);
    const [regionOptions, setRegionOptions] = useState<any>([]);
    const [countryOptions, setCountryOptions] = useState<any>([]);
    const overviewViewType = useSelector(getOverviewViewType);
    const [selectedDomain, setSelectedDomain] = useState<string>('');
    const [selectedAlertData, setSelectedAlertData] = useState(OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT);
    const [selectedStatus, setSelectedStatus] = useState<string>('');
    const [multiSelectedOpReviewer, setMultiSelectedOpReviewer] = useState<any>([])
    const [multiSelectedOpOrg, setMultiSelectedOpOrg] = useState<any>([])
    const [allSelectReviewer, setAllSelectReviewer] = useState(false);
    const [allSelectOrg, setAllSelectOrg] = useState(false);
    const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string[]>([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const { status: lookupStatus, data: filtersListData } = useSelector(
        getLookupStatusSelector
      );
      const [filtersList, setFilterList] = useState<IAnomaliesFilterModel[]>();
    const [localFilterList, setLocalFilters] = useState<any>([]);
    const [filterTouched, setFiltersTouched] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const viewType = useSelector(getOverviewViewType);
    const postFilters = useSelector(getPostFiltersSelector);
    const dispatch = useDispatch();
    const filterCloneData = useRef({});
    const currentRole = useSelector(getCurrentRole);
    const isOrgUser = currentRole === USER_ROLE.ORG_USER; 
    const filterDisplay: string = getMessage('app.anomalies.actions.filters');
    const allfilters : string = getMessage('app.anomalies.action.filters.allfilters');


    const clickOutside = useRef(null);

    useEffect(() => {
        if (props.isOrphanFilter) {
          const{STATUS, REVIEWER, ORGUSER}  = ANOMALIES_LOOKUP_NAMES;
          const removedFilterList=[STATUS, REVIEWER, ORGUSER];
          const orphanFilterList=filtersListData?.filter(({lookup_name}:IAnomaliesFilterModel)=>!removedFilterList.includes(lookup_name))
          orphanFilterList?.map((value, key)=>{
            if(value.lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE){
                orphanFilterList[key] = {...orphanFilterList[key], lookup_name: ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME, lookup_req_column: ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME};
            }
          })
          setFilterList(orphanFilterList);
        } else {
          setFilterList(filtersListData);
        }
      }, [filtersListData, props.isOrphanFilter]);

    useEffect(() => {
        if (isOverviewDashboard(overviewViewType)) {
            refreshAndUpdateFilters(dashboardFilter)
        } else if (props.isSamplingFilter) {
            refreshAndUpdateFilters(samplingFilter);
        } else if (props.isOrphanFilter) {
            refreshAndUpdateFilters(orphanFilter);
        } else {
            refreshAndUpdateFilters(allAnomalyFilters)
        }
    }, [dashboardFilter, allAnomalyFilters, filtersList, samplingFilter,orphanFilter]);

    useEffect(() => {
        if (noFilterSelected() && !filterTouched) {
            setButtonDisable(true);
        } else {
            setButtonDisable(false);
        }
    }, [selectedDomain, selectedStatus, multiSelectedOpReviewer, multiSelectedOpOrg, selectedCountry, selectedAlertData, selectedRegions]);

    const noFilterSelected = () => {
        if (selectedDomain === '' &&
            selectedAlertData === OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT &&
            selectedStatus === '' &&
            multiSelectedOpReviewer.length == 0 &&
            multiSelectedOpOrg.length == 0 &&
            selectedCountry.length == 0 &&
            selectedRegions.length == 0) {
            return true
        }
        return false;
    }

    const refreshAndUpdateFilters = (updatedFilters: any) => {
        if (!updatedFilters.length && viewType !== VIEW_TYPE.PENDING_ACTIONS) {
            resetFilter();
            dispatch(setOverviewViewType(""));
        }
        if (props.isOrphanFilter) {
            // Sending view type for orphan filter 
            dispatch(setOverviewViewType(UNASSIGNED_ANOMALIES));
        }
        if (!equal(updatedFilters, localFilterList) && filtersList) {
            resetSelectedFilters(updatedFilters, localFilterList)
            setLocalFilters([...updatedFilters]);
            updatedFilters.forEach((element: any) => {
                let filter: IAnomaliesFilterModel | any = {}
                if (STATUS_TYPES.includes(element.column))
                    filter = filtersList?.find((filter: any) => (filter.lookup_req_column === ANOMALIES_LOOKUP_NAMES.INSIGHT_STATUS));
                else
                    filter = filtersList?.find((filter: any) => (filter.lookup_name === element.column || filter.lookup_req_column === element.column));
                if (filter && filter.lookup_req_column && !foundInLocalFilters(filter.lookup_req_column, localFilterList)) {
                    loadDataIntoControl(filter.lookup_req_column);
                }
                if(element.column==="alert"){
                    handleFilterSelectionData(element.displayValues[0], element.column);
                    updateMultiSelectFilterData(element.displayValues[0], element.column);

                }else{
                    handleFilterSelectionData(element.value, element.column);
                    updateMultiSelectFilterData(element.value, element.column);
                }
            });
        }
    }

    const foundInLocalFilters = (column: string, localFilterList: any) => {
        const lookupFilter = filtersList?.find((filter: any) => filter.lookup_req_column === column);
        if (lookupFilter) {
            let found = localFilterList.find((filter: any) => (filter.column === lookupFilter.lookup_name || filter.column === lookupFilter.lookup_req_column));
            return found ? true : false;
        }
        return false
    }


    const resetSelectedFilters = (updatedFilters: any, localFilterList: any) => {
        let removedFilters = localFilterList.filter((local: any) => !updatedFilters.some((updated: any) => updated.column === local.column));
        removedFilters.forEach((filter: any) => {
            handleFilterSelectionData('', filter.column);
            updateMultiSelectFilterData([], filter.column);
        })
    }
    const updateMultiSelectFilterData = (value: string[], column: string) => {
        if (column === ANOMALIES_LOOKUP_NAMES.REVIEWER) {
            let reviewerOptions_new = reviewerOptions.map((reviewer: any) => {
                if (value.includes(reviewer.value)) {
                    return { ...reviewer, checked: true }
                } else {
                    return { ...reviewer, checked: false }
                }
            });
            setReviewerOptions(reviewerOptions_new);
            setMultiSelectedOpReviewer([...value]);
        } else if (column === ANOMALIES_LOOKUP_NAMES.ORGUSER) {
            let orgOptions_new = orgOptions.map((reviewer: any) => {
                if (value.includes(reviewer.value)) {
                    return { ...reviewer, checked: true }
                } else {
                    return { ...reviewer, checked: false }
                }
            });
            setOrgOptions(orgOptions_new);
            setMultiSelectedOpOrg([...value]);
        } else if (column === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || column === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) {
            setSelectedCountry([...value]);
        } else if (column === ANOMALIES_LOOKUP_NAMES.REGION) {
            setSelectedRegions([...value]);
            setSelectedCountry([]);
        }
    }


    const handleInternalData = (lookupName: string, lookupDetail: ILookUpDetailModal[], internalStateValue: any) => {
        if (lookupName === ANOMALIES_LOOKUP_NAMES.REVIEWER && lookupName === ANOMALIES_LOOKUP_NAMES.ORGUSER) {
            lookupDetail?.map((data) => {
                data.lookup_value && internalStateValue.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text, checked: false });
            })
        } else if (lookupName === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || lookupName === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) {
            lookupDetail?.map((data) => {
                data.lookup_value && internalStateValue.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
            })
        } else
            lookupDetail?.map((data) => {
                data.lookup_value && internalStateValue.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
            })
    }

    const handleAlertData = (parent: string, selecteditem: string) => {
        setSelectedAlertData(selecteditem);
    }
    const handleInputCheckboxChange = (e: any, lookup_name: string) => {
        let index;
        if (lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER) {
            setAllSelectReviewer(false);
            const res = reviewerOptions.map((d: any) => {
                if (d.value == e.target.value)
                    return { ...d, checked: !d.checked };

                return d;
            });
            setReviewerOptions(res)
            if (e.target.checked) {
                const selectedOpRev = []
                selectedOpRev.push(...multiSelectedOpReviewer);
                selectedOpRev.push(e.target.name);
                setMultiSelectedOpReviewer(selectedOpRev)
            } else {
                index = multiSelectedOpReviewer.indexOf(e.target.value);
                multiSelectedOpReviewer.splice(index, 1)
            }
        }
        if (lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER) {
            setAllSelectOrg(false)
            const res = orgOptions.map((d: any) => {
                if (d.value == e.target.value)
                    return { ...d, checked: !d.checked };

                return d;
            });
            setOrgOptions(res)
            if (e.target.checked) {
                const selectedOpOrg = []
                selectedOpOrg.push(...multiSelectedOpOrg);
                selectedOpOrg.push(e.target.name);
                setMultiSelectedOpOrg(selectedOpOrg)
            } else {
                index = multiSelectedOpOrg.indexOf(e.target.value);
                multiSelectedOpOrg.splice(index, 1)
            }
        }
    }
    const handleMultiAllSelectData = (e: any, lookup_name: string) => {
        let res: any = [];
        switch (lookup_name) {
            case ANOMALIES_LOOKUP_NAMES.REVIEWER:
                setAllSelectReviewer(!allSelectReviewer);

                res = reviewerOptions.map((d: any) => {
                    return { ...d, checked: !allSelectReviewer };
                });
                setReviewerOptions(res)
                if (e.target.checked) {
                    const res = reviewerOptions.map((d: any) => {
                        return d.text
                    });
                    setMultiSelectedOpReviewer(res)
                } else setMultiSelectedOpReviewer([])
                break;
            case ANOMALIES_LOOKUP_NAMES.ORGUSER:
                setAllSelectOrg(!allSelectOrg)
                res = orgOptions.map((d: any) => {
                    return { ...d, checked: !allSelectOrg };
                });
                setOrgOptions(res)
                if (e.target.checked) {
                    const res = orgOptions.map((d: any) => {
                        return d.text
                    });
                    setMultiSelectedOpOrg(res)
                } else setMultiSelectedOpOrg([])
                break;
        }

    }
    const handleFilterSelectionData = async (SelectedValue: string, selectedColumn: string, item?: any) => {
        switch (selectedColumn) {
            case ANOMALIES_LOOKUP_NAMES.DOMAIN:
            case ANOMALIES_LOOKUP_NAMES.DOMAIN2:
                setSelectedDomain(SelectedValue);
                break;
            case ANOMALIES_LOOKUP_NAMES.ALERT:
            case ANOMALIES_LOOKUP_NAMES.ALERT2:
                setSelectedAlertData(SelectedValue);
                if (SelectedValue === '') setSelectedAlertData(OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT);
                break;
            case ANOMALIES_LOOKUP_NAMES.STATUS:
            case ANOMALIES_LOOKUP_NAMES.INSIGHT_STATUS:
            case ANOMALIES_LOOKUP_NAMES.AUDIT_STATUS:
            case ANOMALIES_LOOKUP_NAMES.BUSINESS_STATUS:
                if (!(SelectedValue == 'All' || SelectedValue === 'all'))
                    setSelectedStatus(SelectedValue);
                break;
        }
    }

    const resetFilter = () => {
        setSelectedDomain("");
        setSelectedAlertData(OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT);
        setSelectedStatus("");
        setMultiSelectedOpReviewer([]);
        const resRev = reviewerOptions.map((d: any) => {
            return { ...d, checked: false };
        });
        setReviewerOptions(resRev);
        setAllSelectReviewer(false);
        setMultiSelectedOpOrg([])
        const resOrg = orgOptions.map((d: any) => {
            return { ...d, checked: false };
        });
        setOrgOptions(resOrg);
        setAllSelectOrg(false);
        setSelectedCountry([]);
        setSelectedRegions([]);
        setLocalFilters([]);
    }
    const handleResetFilter = () => {
        resetFilter();
        dispatch(setOverviewViewType(""));
        dispatch(addDashboardFilter([]));
        dispatch(addAllAnomalyFilters([]));
        if(props.isSamplingFilter){
            dispatch(addSamplingFilters([]));
            dispatch(getallSamplingOpportunities());
        }
        dispatch(getallOpportunities());
        props.onFiltersClick();
        setFiltersTouched(false);
    }

    const getUserInputFilters = () => {
        const applyFilterLocalData: any = [];
        filtersList?.map((values) => {
            if(props.isOrphanFilter){
                if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.DOMAIN && (selectedDomain !== '')) {
                    let lookupdomainColumn = domainOptions.filter((items: any) => { return items.value === (selectedDomain.length == 1 ? selectedDomain[0] : selectedDomain) })
                    lookupdomainColumn.length && applyFilterLocalData.push({
                        column: lookupdomainColumn[0]?.column,
                        value: selectedDomain.length == 1 ? selectedDomain : [selectedDomain],
                        type: 'in',
                        displayValues: [lookupdomainColumn[0].text || selectedDomain]
                    })
                }
            }else{
                if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.DOMAIN && (selectedDomain !== '')) {
                    let lookupdomainColumn = domainOptions.filter((items: any) => { return items.value === selectedDomain })
                    lookupdomainColumn.length && applyFilterLocalData.push({
                        column: lookupdomainColumn[0]?.column,
                        value: [selectedDomain],
                        type: 'in',
                        displayValues: [lookupdomainColumn[0].text || selectedDomain]
                    })
                }
            }
            if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.ALERT && selectedAlertData !== OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT) {
                //  let lookupalertColumn = alertOptions.filter((items: any) => { return items.value === selectedAlertData })
                applyFilterLocalData.push({
                    column: values.lookup_req_column,
                    value: [selectedAlertData],
                    type: 'in',
                    displayValues: [selectedAlertData]
                })
            }
            if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.STATUS && selectedStatus !== '') {
                let lookupstatusColumn = statusOptions.filter((items: any) => { return items.value === selectedStatus })
                lookupstatusColumn.length && applyFilterLocalData.push({
                    column: lookupstatusColumn[0].column,
                    value: [selectedStatus],
                    type: 'in',
                    displayValues: [lookupstatusColumn[0].text || selectedStatus]
                })
            }
            if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER && multiSelectedOpReviewer.length !== 0 && !allSelectReviewer) {
                let lookupreviewerColumn = reviewerOptions.filter((items: any) => { return items.value === multiSelectedOpReviewer[0] })
                lookupreviewerColumn.length && applyFilterLocalData.push({
                    column: lookupreviewerColumn[0].column,
                    value: multiSelectedOpReviewer,
                    type: 'in',
                    displayValues: null
                })
            }
            if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER && multiSelectedOpOrg.length !== 0 && !allSelectOrg) {
                let lookuporgUserColumn = orgOptions.filter((items: any) => { return items.value === multiSelectedOpOrg[0] })
                lookuporgUserColumn.length && applyFilterLocalData.push({
                    column: lookuporgUserColumn[0].column,
                    value: multiSelectedOpOrg,
                    type: 'in',
                    displayValues: multiSelectedOpOrg
                })
            }
            if (values.lookup_name === ANOMALIES_LOOKUP_NAMES.REGION && (selectedRegions.length != 0)) {
                applyFilterLocalData.push({
                    column: values.lookup_name,
                    value: [...selectedRegions],
                    type: 'in',
                })
            }
            if ((values.lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || values.lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) && (selectedCountry.length != 0)) {
                let lookupcountryColumn = countryOptions.filter((items: any) => { return selectedCountry.includes(items.value) })
                applyFilterLocalData.push({
                    column: values.lookup_name,
                    value: [...selectedCountry],
                    type: 'in',
                    displayValues: [...lookupcountryColumn.map((country: any) => country.text)]
                })
            }
        })
        return applyFilterLocalData;
    }

    const handleApplyOnClick = () => {
        let applyFilterLocalData: any = [];
        applyFilterLocalData = [...getUserInputFilters()];
        props.onApplyOrReset();
        if (props.isSamplingFilter === true) {
            dispatch(addSamplingFilters(mergeFilters([], applyFilterLocalData)));
            dispatch(getallSamplingOpportunities());
            props.onFiltersClick();
        }else if (props.isOrphanFilter === true) {  
            applyFilterLocalData?.map((value:any,index:number)=>{
                if(value.column == "country_code"){
                    applyFilterLocalData[index] = {...applyFilterLocalData[index], column:COUNTRY_NAME}
                }
            })      
            dispatch(addOrphanFilters(mergeFilters([], applyFilterLocalData)));
            dispatch(getallOrphanOpportunities());         
            props.onFiltersClick();
        }else{  
            if (isOverviewDashboard(overviewViewType)) {
                dispatch(addDashboardFilter(mergeFilters(dashboardFilter, applyFilterLocalData)));
                setLocalFilters([...mergeFilters(dashboardFilter, applyFilterLocalData)]);
            } else {
                dispatch(addAllAnomalyFilters(mergeFilters([], applyFilterLocalData)));
                setLocalFilters([...mergeFilters([], applyFilterLocalData)]);
            }
            dispatch(getallOpportunities());
            props.onFiltersClick();
        }
        if (noFilterSelected()) {
            setFiltersTouched(false);
        }
    }

    const disableStatus = (column: string) => {
        return column === ANOMALIES_LOOKUP_NAMES.STATUS && overviewViewType === VIEW_TYPE.USER_ACTIVITY;
    }

    const LoadingStatusOption = (requestedDropdown: string) => {
        switch (requestedDropdown) {
            case ANOMALIES_LOOKUP_NAMES.DOMAIN2:
            case ANOMALIES_LOOKUP_NAMES.DOMAIN:
                setDomainOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.ALERT:
            case ANOMALIES_LOOKUP_NAMES.ALERT2:
                //setAlertOptions([{ value: "", column:"Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.STATUS:
                setStatusOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.REVIEWER:
                setReviewerOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.ORGUSER:
                setOrgOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE:
                setCountryOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
            case ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME:
                setCountryOptions([{ value: "", column: "Loading", text: "Loading..." }]);
                break;
        }

    }


    const loadDataIntoControl = async (requestedDropdown: string) => {
        let data: any = {};
        data["current_role"] = currentRole || '';
        if (props.isSamplingFilter) {
            data["sampling"] = true;
        }
        if (props.isOrphanFilter) {
            data["orphan"] = true;
        }
        data["view_type"] = overviewViewType;
        const applyFilterLocalData = [...getUserInputFilters()];
        let localFilters = getUniqueoptions([...dashboardFilter, ...applyFilterLocalData], 'column');
        let optionFilters = localFilters.filter((item: any) => {
            return !(item.value.includes("All") || item.value.includes("all")) && !item.column.includes(requestedDropdown);
        })
        if (overviewViewType && !props.isOrphanFilter)
            data["filters"] = mapFilterColumns(optionFilters);
        else {
            if (requestedDropdown === ANOMALIES_LOOKUP_NAMES.REGION) {
                optionFilters = optionFilters.filter((item: any) => item.column !== ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE)
            }
            
            if (isOrgUser && requestedDropdown === ANOMALIES_LOOKUP_NAMES.INSIGHT_STATUS) {
                optionFilters = [...optionFilters,...postFilters]
            }
            data["filters"] = [...optionFilters];
        }

        data["requested_dropdown"] = requestedDropdown;



        if (filterCloneData.current !== JSON.stringify(data)) {
            filterCloneData.current = JSON.stringify(data);
            LoadingStatusOption(requestedDropdown);
            setLoader(true)
            getFilterOptions(data)
                .then((response: any) => {
                    response?.map((item: any) => {
                        switch (item.lookup_name) {
                            
                            case ANOMALIES_LOOKUP_NAMES.DOMAIN:
                                const domain = [];
                                item.lookup_detail.length > 1 && domain.push({ value: "all", column: "all", text: "All" });
                                handleInternalData(item.lookup_name, item.lookup_detail, domain);
                                setDomainOptions(getUniqueoptions(domain, 'text'));
                                break;
                            case ANOMALIES_LOOKUP_NAMES.REGION:
                                const regions: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, regions);
                                setRegionOptions(getUniqueoptions(regions, 'text'));
                                break;
                            case ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE:
                                const country: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, country);
                                setCountryOptions(getUniqueoptions(country, 'text'));
                                break;
                            case ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME:
                                const country_name: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, country_name);
                                setCountryOptions(getUniqueoptions(country_name, 'text'));
                                break;
                            case ANOMALIES_LOOKUP_NAMES.STATUS:
                                const status: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, status);
                                setStatusOptions(getUniqueoptions(status, 'text'));
                                break;
                            case ANOMALIES_LOOKUP_NAMES.REVIEWER:
                                const reviewers: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, reviewers);
                                setReviewerOptions(getUniqueoptions(reviewers, 'text'))
                                break;
                            case ANOMALIES_LOOKUP_NAMES.ORGUSER:
                                const orgOp: any = [];
                                handleInternalData(item.lookup_name, item.lookup_detail, orgOp);
                                setOrgOptions(getUniqueoptions(orgOp, 'text'));
                                break;

                            case ANOMALIES_LOOKUP_NAMES.ALERT:
                                setLoader(false)
                                const procurementData: any = [];
                                const salesData: any = [];
                                const projectData:any = [];
                                const pricingData: any = [];
                                const financeData: any = [];
                                const complianceData:any = [];
                                item.lookup_detail?.map((data: any) => {
                                    if (data.domain === OVERVIEW_DOMAIN_CATEGORY.FINANCE) {
                                        financeData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    } else if (data.domain === OVERVIEW_DOMAIN_CATEGORY.PRICING) {
                                        pricingData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    } else if (data.domain === OVERVIEW_DOMAIN_CATEGORY.PROCUREMENT) {
                                        procurementData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    } else if (data.domain === OVERVIEW_DOMAIN_CATEGORY.PROJECT) {
                                        projectData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    } else if (data.domain === OVERVIEW_DOMAIN_CATEGORY.SALES) {
                                        salesData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    } 
                                    else if (data.domain === OVERVIEW_DOMAIN_CATEGORY.COMPLIANCE) {
                                        complianceData.push({ value: data.lookup_value, column: data.lookup_column, text: data.display_text });
                                    }
                                })
                                if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.FINANCE) {
                                    setAlertOptions([{ parent: selectedDomain, child: financeData }]);
                                } else if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.PRICING) {
                                    setAlertOptions([{ parent: selectedDomain, child: pricingData }]);
                                } else if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.PROCUREMENT) {
                                    setAlertOptions([{ parent: selectedDomain, child: procurementData }]);
                                } else if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.SALES) {
                                    setAlertOptions([{ parent: selectedDomain, child: salesData }]);
                                } else if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.PROJECT) {
                                    setAlertOptions([{ parent: selectedDomain, child: projectData }]);
                                }
                                else if (selectedDomain === OVERVIEW_DOMAIN_CATEGORY.COMPLIANCE) {
                                    setAlertOptions([{ parent: selectedDomain, child: complianceData }]);
                                }
                                else {
                                    let alertObj: Array<any> = [];
                                    if (financeData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.FINANCE, child: financeData });
                                    }
                                    if (pricingData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.PRICING, child: pricingData });
                                    }
                                    if (procurementData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.PROCUREMENT, child: procurementData });
                                    }
                                    if (salesData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.SALES, child: salesData });
                                    }
                                    if (projectData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.PROJECT, child: projectData });
                                    }
                                    if (complianceData.length >= 1) {
                                        alertObj.push({ parent: OVERVIEW_DOMAIN_CATEGORY.COMPLIANCE, child: complianceData });
                                    }
                                    setAlertOptions(alertObj);
                                }
                                break;
                        }
                    })
                })
                .catch(() => {
                    console.log("Anomaly API Issue")
                })
        }
    }

    const useFilterHideReference = (ref: any) => {
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    props.filterClose();
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    useFilterHideReference(clickOutside)

    const handleRemoveOption = (e: any, lookupName: string) => {
        e.stopPropagation();
        if (lookupName === ANOMALIES_LOOKUP_NAMES.REVIEWER) {
            const resRev = multiSelectedOpReviewer.filter((val: any) => val !== e.target.title)
            setMultiSelectedOpReviewer(resRev);
            const res = reviewerOptions.map((d: any) => {
                if (d.text == e.target.title)
                    return { ...d, checked: false };

                return d;
            });
            setReviewerOptions(res)
        }
        if (lookupName === ANOMALIES_LOOKUP_NAMES.ORGUSER) {
            const resOrg = multiSelectedOpOrg.filter((val: any) => val !== e.target.title)
            setMultiSelectedOpOrg(resOrg)
            const res = orgOptions.map((d: any) => {
                if (d.text == e.target.title)
                    return { ...d, checked: false };

                return d;
            });
            setOrgOptions(res)
        }
    }

    return (
        <>
            <div>
                <Button className={`anomaliesHeader__actions__btn btn_filters ${props.filterDisable ? 'anomaliesHeader__actions__btndisbled' : ''} ${props.isFilterOpen ? 'selected' : ''}`}
                    icon={<Icon root="common" name="filter1" size="small" color="#005EAC" />}
                    iconPosition="left"
                    type="secondary"
                    content={filterDisplay}
                    onClick={() => props.onFiltersClick()}
                ></Button>
            </div>
            {props.isFilterOpen &&
                <div className='anomalies-filters anomalies-filters__section' ref={clickOutside}>
                    <div className="anomalies-filters__title">
                        <span>{allfilters}</span>
                        <FontIcon className="anomalies-filters--close" data-testid='close-btn' iconName='fa-close' iconSize='medium' onClick={() => props.onFiltersClick()} />
                    </div>
                    <div className='anomalies-filters__content'>
                        <div className='filters_content_section'>
                            {
                                filtersList?.map((item) => {
                                    const lookup_name = item.lookup_name;
                                    const lookup_column = item.lookup_req_column;
                                    const ismulti = lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME || lookup_name === ANOMALIES_LOOKUP_NAMES.REGION;
                                    return lookup_name === ANOMALIES_LOOKUP_NAMES.ALERT ?
                                        <div className="dropdown_component">
                                            <Dropdown loader={loader} dropdownData={alertOptions} label="Select alert" onFiltersClick={handleAlertData} selectedData={selectedAlertData || 'Select alert'} onClickFunction={loadDataIntoControl} columDetails={lookup_column}></Dropdown>
                                        </div> : lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER || lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ?
                                            <div className='dropdown_component'>
                                                <Multiselect label={`Select ${lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER ? 'reviewer' : lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ? 'org owner' : lookup_name}`}
                                                    dropdownData={lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER ? reviewerOptions : lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ? orgOptions : ''}
                                                    dropDownDataFunction={loadDataIntoControl}
                                                    //@ts-ignore
                                                    columnDetails={lookup_column}
                                                    handleAllSelect={(e: any) => handleMultiAllSelectData(e, lookup_name)} handleInputCheckboxChange={(e: any) => handleInputCheckboxChange(e, lookup_name)}
                                                    selectAllDropdown={lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER ? allSelectReviewer : lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ? allSelectOrg : false}
                                                    multiSelectData={lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER ? multiSelectedOpReviewer : lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ? multiSelectedOpOrg : ''}
                                                    handleRemoveOption={(e: any) => handleRemoveOption(e, lookup_name)} />
                                            </div>
                                            : <Select
                                                className={`${ismulti && 'multi-dropdown-filter'} custom-select anomalies-filters__content--dropdown`}
                                                multiple={ismulti}
                                                //@ts-ignore
                                                onFocus={() => loadDataIntoControl(lookup_column)}
                                                disabled={disableStatus(lookup_name)}
                                                label={`Select ${lookup_name === ANOMALIES_LOOKUP_NAMES.DOMAIN ? 'domain' :
                                                    lookup_name === ANOMALIES_LOOKUP_NAMES.STATUS ? 'status' :
                                                        lookup_name === ANOMALIES_LOOKUP_NAMES.REVIEWER ? 'reviewer' :
                                                        (lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) ? 'country' :
                                                                lookup_name === ANOMALIES_LOOKUP_NAMES.ORGUSER ? 'org owner' :
                                                                    lookup_name === ANOMALIES_LOOKUP_NAMES.REGION ? 'region' :
                                                                        lookup_name}`}
                                                placeholder={OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT}
                                                options={lookup_name === ANOMALIES_LOOKUP_NAMES.DOMAIN ? domainOptions :
                                                    lookup_name === ANOMALIES_LOOKUP_NAMES.STATUS ? statusOptions :
                                                        (lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) ? countryOptions :
                                                            lookup_name === ANOMALIES_LOOKUP_NAMES.REGION ? regionOptions : []
                                                }
                                                value={lookup_name === ANOMALIES_LOOKUP_NAMES.DOMAIN ? typeof selectedDomain === "string"? selectedDomain: selectedDomain[0]:
                                                    lookup_name === ANOMALIES_LOOKUP_NAMES.STATUS ? typeof selectedStatus === "string"?selectedStatus:selectedStatus[0] :
                                                    (lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_CODE || lookup_name === ANOMALIES_LOOKUP_NAMES.COUNTRY_NAME) ? selectedCountry :
                                                            lookup_name === ANOMALIES_LOOKUP_NAMES.REGION ? selectedRegions :
                                                                OVERVIEW_DOMAIN_CATEGORY.RESET_TEXT}
                                                onChange={(e) => {
                                                    ismulti ?
                                                        updateMultiSelectFilterData(e, lookup_name) :
                                                        handleFilterSelectionData(e, lookup_name);
                                                    setFiltersTouched(true)
                                                }}
                                            />
                                })
                            }

                        </div>
                        <div className="filters__content_button">
                            <Button
                                className="button--secondary"
                                size="small"
                                type="secondary"
                                content="Reset"
                                onClick={handleResetFilter}
                                disabled={buttonDisable}
                            />
                            <Button
                                className="button--primary"
                                size="small"
                                type="primary"
                                content="Apply"
                                onClick={handleApplyOnClick}
                                disabled={buttonDisable}
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default AnomalyFilters;